interface Props {
  offset: number;
  refreshing: boolean;
}

/**
 * Visual indicator above a pull-to-refresh container. Renders inside the
 * pulled element; transform comes from the parent. Just a thin spinner glyph.
 */
export function PullIndicator({ offset, refreshing }: Props): JSX.Element | null {
  if (offset === 0 && !refreshing) return null;
  const rotate = Math.min(360, (offset / 60) * 180);
  return (
    <div
      className="pointer-events-none absolute left-0 right-0 top-0 -translate-y-full flex justify-center pt-2"
      aria-hidden
    >
      <div className="h-7 w-7 rounded-full border-2 border-brand-green border-t-transparent" style={{
        transform: refreshing ? undefined : `rotate(${rotate}deg)`,
        animation: refreshing ? 'spin 0.8s linear infinite' : undefined,
      }} />
    </div>
  );
}
